var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c("div", { staticClass: "info-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "back",
            on: {
              click: function ($event) {
                return _vm.$router.push("/exam/gaokao")
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("images/back.png"), width: "10" },
            }),
            _c("span", [_vm._v("返回")]),
          ]
        ),
        _c("div", { staticClass: "info" }, [
          _c("h4", [_vm._v(_vm._s(_vm.examName))]),
          _c(
            "div",
            { staticClass: "subject-list" },
            _vm._l(_vm.subjectNames, function (sub, index) {
              return _c("div", { key: index, staticClass: "tool-subject" }, [
                _c("span", [_vm._v(_vm._s(sub.slice(0, 1)))]),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "date" }, [
            _c("img", {
              attrs: { src: require("images/time.png"), width: "16" },
            }),
            _c("label", [_vm._v(_vm._s(_vm.examDate))]),
          ]),
        ]),
        _vm.isRegion === false
          ? _c(
              "div",
              { staticClass: "setting", on: { click: _vm.pathToSetting } },
              [_c("img", { attrs: { src: require("images/setting.png") } })]
            )
          : _vm._e(),
      ]),
      _c("header", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "report-button" },
          _vm._l(_vm.routerKinds, function (item, index) {
            return _c(
              "router-link",
              {
                directives: [
                  {
                    name: "authvalidate",
                    rawName: "v-authvalidate",
                    value: item.auth,
                    expression: "item.auth",
                  },
                ],
                key: "route" + index,
                staticClass: "menu-tab",
                class: {
                  actived:
                    _vm.$route.path.indexOf(item.parentPath || item.path) >= 0,
                },
                attrs: { tag: "a", to: _vm.getRoute(item) },
              },
              [_vm._v(" " + _vm._s(item.label) + " ")]
            )
          }),
          1
        ),
        _c("div", { staticStyle: { flex: "1" } }),
        !_vm.isRegion
          ? _c("div", { staticClass: "export-report" }, [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "top",
                    on: {
                      click: function ($event) {
                        return _vm.exportData()
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("images/export_report.png"),
                        width: "24",
                      },
                    }),
                    _c("span", [_vm._v("导出报表")]),
                  ]
                ),
                _c("div", { staticStyle: { height: "18px", clear: "both" } }),
              ]),
            ])
          : _vm._e(),
      ]),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "main" },
            [
              _c("router-view", {
                attrs: {
                  "grade-id": _vm.gradeId,
                  "is-more": _vm.isMore,
                  "is-split": _vm.isSplit,
                  "subject-list": _vm.subjectList,
                  "school-id": _vm.userInfo.schoolId,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("export-modal", {
        ref: "exportModal",
        attrs: {
          reportList: _vm.reportList,
          "school-all-report": _vm.schoolAllReport,
          showSixRete: false,
        },
        on: { "click-item": _vm.clickItem },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }